import axios from "axios";
import { 
  getCentreCustomMessagesURL,
  getActiveCentreCustomMessageURL,
  createCentreCustomMessageURL,
  updateCentreCustomMessageURL,
  activateCentreCustomMessageURL,
  deactivateCentreCustomMessageURL,
  deleteCentreCustomMessageURL
} from "@app/constants/ApiEndPoints";

export const getMessagesByCentre = async (centreId: number) => {
  try {
    const response = await axios.get(getCentreCustomMessagesURL(centreId));
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error?.response?.data;
  }
};

export const getActiveMessage = async (centreId: number) => {
  try {
    const response = await axios.get(getActiveCentreCustomMessageURL(centreId));
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error?.response?.data;
  }
};

export const createMessage = async (centreId: number, payload: any) => {
  try {
    const response = await axios.post(createCentreCustomMessageURL(centreId), payload);
    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateMessage = async (centreId: number, messageId: number, payload: any) => {
  try {
    const response = await axios.put(updateCentreCustomMessageURL(centreId, messageId), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error?.response?.data;
  }
};

export const activateMessage = async (centreId: number, messageId: number) => {
  try {
    const response = await axios.put(activateCentreCustomMessageURL(centreId, messageId));
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error?.response?.data;
  }
};

export const deactivateMessage = async (centreId: number, messageId: number) => {
  try {
    const response = await axios.put(deactivateCentreCustomMessageURL(centreId, messageId));
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error?.response?.data;
  }
};

export const deleteMessage = async (centreId: number, messageId: number) => {
  try {
    const response = await axios.delete(deleteCentreCustomMessageURL(centreId, messageId));
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return error?.response?.data;
  }
};
